import http from 'helpers/APIHelper';
import { httpStatusEnum } from 'appconstants';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';
import { getProtocolDetails } from '../protocoldetail';

export const STUDY_AGENT_ACTIONS = {
  GET_CTEP_STUDY_AGENTS: '@protocol/studyagents/getctepstudyagents',
  GET_NON_CTEP_STUDY_AGENTS_IND:
    '@protocol/studyagents/getnonctepstudyagents',
  GET_PHARMA:
    '@protocol/studyagents/getpharma',
  SAVE_INDINFO: '@protocol/version/savenonctepstudyagents'
};

export const getCtepStudyAgentDetails = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: STUDY_AGENT_ACTIONS.GET_CTEP_STUDY_AGENTS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/ctepstudyagents`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: STUDY_AGENT_ACTIONS.GET_CTEP_STUDY_AGENTS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: STUDY_AGENT_ACTIONS.GET_CTEP_STUDY_AGENTS + suffixRejected,
          payload: error
        });
      }
    );
};

export const getNonCtepStudyAgentDetails = (
  token,
  loggerInfo,
  id,
  type
) => dispatch => {
  dispatch({
    type: STUDY_AGENT_ACTIONS.GET_NON_CTEP_STUDY_AGENTS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/nonctepstudyagents/${type}`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type:
            STUDY_AGENT_ACTIONS.GET_NON_CTEP_STUDY_AGENTS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type:
            STUDY_AGENT_ACTIONS.GET_NON_CTEP_STUDY_AGENTS + suffixRejected,
          payload: error
        });
      }
    );
};

export const saveNonCTEPStudyAgents = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/nonctepstudyagents`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getProtocolDetails(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const cancelStudyAgent = (token, loggerInfo, id, csaId, type) => (
  dispatch,
  getState
) => http
  .deleteWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/nonctepstudyagents/${csaId}`,
    token,
    loggerInfo
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getNonCtepStudyAgentDetails(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber,
            type
          )
        );
      }
      return resp;
    })
  );
